import { AxiosInstance } from "axios";
import { Promotion } from "../models/giveaway";

const GIVEAWAY_API_PREFIX = "/draws/draws";

export const getPromotionDetails = async (
	http: AxiosInstance,
	id: number
): Promise<Promotion> => {
	const body = await http.get<any>(`${GIVEAWAY_API_PREFIX}/draw/${id}`);
	return body.data as Promotion;
};

export const getActivePromotions = async (
	http: AxiosInstance
): Promise<Promotion[]> => {
	const body = await http.get<any>(`${GIVEAWAY_API_PREFIX}/active-draws`);
	return (body.data || []) as Promotion[];
};

export const getUpcomingPromotions = async (
	http: AxiosInstance
): Promise<Promotion[]> => {
	const body = await http.get<any>(`${GIVEAWAY_API_PREFIX}/upcoming-draws`);
	return (body.data || []) as Promotion[];
};

export const getPreviousWinners = async (
	http: AxiosInstance
): Promise<Promotion[]> => {
	const body = await http.get<any>(`${GIVEAWAY_API_PREFIX}/previous-winners`);
	return (body.data || []) as Promotion[];
};

export const getUserDrawsWithEntryCount = async (
	http: AxiosInstance
): Promise<Promotion[]> => {
	const body = await http.get<any>(`${GIVEAWAY_API_PREFIX}/user-draws`);
	return (body.data || []) as Promotion[];
};
